export default __webpack_public_path__ + "static/media/1531.7b4a2d11.png";